const fflip = require('fflip')
const fflipCOnfig = require('./config')
fflip.config(fflipCOnfig)

const isFeatureAllowed = function isFeatureAllowed (featureId, location) {
  if (!location) {
    return false
  }
  return fflip.isFeatureEnabledForUser(featureId, location)
}

module.exports = isFeatureAllowed



// WEBPACK FOOTER //
// ./src/services/features/feature-check.js